import React from 'react';
import Header from '../layout/Header/Header';
import MainContent from '../layout/MainContent/MainContent';
import Footer from '../layout/Footer/Footer';

export default function HomeScreen() {
  return (
    <>
      <Header />
      <MainContent />
      <Footer />
    </>
  );
}
